'use strict';

var React = require('react');
var useActiveDevice = require('../../hooks/useActiveDevice.js');
require('imask');
require('../../theme/breakpoints.js');
require('resize-observer-polyfill');
var IziLogo = require('../Logo/IziLogo.js');
var Desktop = require('./Desktop.js');
var Tablet = require('./Tablet.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const HeaderNavBar = React.forwardRef(({ logo = React__default.default.createElement(IziLogo.IziLogo, null), ...props }, ref) => {
    switch (useActiveDevice.useActiveDevice()) {
        case 'mobile':
        case 'tablet':
            return React__default.default.createElement(Tablet.HeaderNavBarTablet, { ...props, logo: logo, ref: ref });
        case 'laptop':
        case 'desktop':
        case null:
            return React__default.default.createElement(Desktop.HeaderNavBarDesktop, { ...props, logo: logo, ref: ref });
    }
});

exports.HeaderNavBar = HeaderNavBar;
//# sourceMappingURL=component.js.map
